import { formatWeight, type GoalProgress, type WeightUnit } from '@tahi/core';
import { copy } from '../copy';

/** Progress toward the goal as a bar plus the same facts in text. */
export function GoalBar({ goal, unit }: { goal: GoalProgress; unit: WeightUnit }) {
  const pct = Math.round(goal.fraction * 100);
  return (
    <div className="flex flex-col gap-2">
      <div
        role="progressbar"
        aria-label={copy.goal}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={pct}
        aria-valuetext={copy.goalPercent(pct)}
        className="h-3 w-full overflow-hidden rounded-full bg-secondary"
      >
        <div className="h-full rounded-full bg-success" style={{ width: `${pct}%` }} />
      </div>
      <p className="text-sm text-fg">
        {goal.reached ? copy.goalReached : copy.goalToGo(formatWeight(goal.remainingG, unit))}
        <span className="text-muted"> · {copy.goalPercent(pct)}</span>
      </p>
      <p className="text-sm text-muted">
        {copy.goalFrom(formatWeight(goal.startG, unit), formatWeight(goal.goalG, unit))}
      </p>
    </div>
  );
}
